import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { PackageDetail } from '@features/packages/pages/Package/PackageDetail';
import { RateDetail } from './RateDetail';
import { RateDetailV2 } from './v2';

export const RateVersion: FC<any> = ({ isPackage, ...props }) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <RateDetailV2 {...props} />;
  return isPackage ? <PackageDetail {...props} /> : <RateDetail {...props} />;
};
